<template>
    <div aria-live="polite" aria-atomic="true" class="mb-3 mt-3">
        <div :class="{
            'toast-default':toast.toastType === ToastType.default,
            'toast-info':toast.toastType === ToastType.info,
            'toast-warning':toast.toastType === ToastType.warning,
            'toast-success':toast.toastType === ToastType.success,
            'toast-danger':toast.toastType === ToastType.danger}" class="w-full  px-3 shadow-sm rounded-lg">
            <div class="p-" v-if="state.fixedMessage">
                <span>{{state.fixedMessage}}</span>
                <hr aria-hidden="true" class="m-0"/>
            </div>
            <div class="p-3">
                <Symbol class="mr-3" :color="'var(--spsm-gray-1)'" symbol="warning" v-if="toast.toastType === ToastType.warning || toast.toastType === ToastType.danger " />
                <strong class="mr-2">{{toast.message}}</strong>
                <button type="button" class="ml-2 mb-1 close text-right" aria-label="Close" @click="state.hideToast()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script lang="ts">

import  {defineComponent, reactive} from "@vue/runtime-core";
import { useToastStore } from "@/stores/toast";
import Symbol from "./Symbol.vue";

enum ToastType {
    default = "default",
    info = "info",
    warning = 'warning',
    danger = 'danger',
    success = 'success'
}

export default  defineComponent({
    components: { 
        Symbol
    },
    name: 'Toast',
    props: {
        toast: { required: true, type: Object }
    },

    setup(props) {
        const toastStore = useToastStore();
        const state = reactive({
            fixedMessage:'',
            hideToast :() => {
                toastStore.clearToast(props.toast.message);
            }
        })
        if(props.toast.disappear) {
                setTimeout(function() {
                    toastStore.clearToast(props.toast.message);
            }, 5000);
        }
        return  {
            props,
            state,
            ToastType
        }
    }
})
</script>

<style lang="scss">
.toast-default {
    background-color: var(--spsm-gray-5);
    border-left: 8px solid var(--spsm-gray-2);
}
.toast-info {
    background-color: var(--spsm-gray-5);
    border-left: 8px solid #5bc0de;
}
.toast-warning {
    background-color: var(--spsm-gray-5);
    border-left: 8px solid #f0ad4e;
}
.toast-success {
    background-color: var(--spsm-gray-5);
    border-left: 8px solid #5cb85c;
}
.toast-danger {
    background-color: var(--spsm-gray-5);
    border-left: 8px solid #d9534f;
}
</style>